import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { useClickOutside } from '@libs/hooks/useClickOutside';
import { useOnEscape } from '@libs/hooks/useOnKeyDown';

import { Radio, Option, Button } from '@features/game/ui/PopupControls';
import stylesControls from '@features/game/ui/PopupControls/PopupControls.module.css';

import styles from './OnlineGamesModal.module.css';

/*
    ____,-------------------------------,____
    \   |           Component           |   /
    /___|-------------------------------|___\
*/

type Props = {
  className?: string;
  title?: string;
  titlePosition?: 'left' | 'center';
  menu?: Option[];
  selected?: string;
  isMobile: boolean;
  children: ReactNode;
  position?: 'centered' | 'static';
  closeText?: string;
  onMenu?: (val: Option) => void;
  onClose?: () => void;
};

export function OnlineGamesModal({
  className,
  title = 'Онлайн-игра',
  titlePosition = 'center',
  position = 'static',
  menu,
  selected,
  isMobile,
  children,
  closeText,
  onMenu,
  onClose,
}: Props) {
  useOnEscape(onClose);

  const ref = useClickOutside<HTMLElement>(() => onClose?.(), {
    enabled: !!onClose && !isMobile,
  });

  return (
    <article
      ref={ref}
      className={cx(styles.settings, stylesControls.container, className, {
        [stylesControls.is_mobile]: isMobile,
        [styles.is_mobile]: isMobile,
        [styles.is_centered]: position === 'centered',
      })}
    >
      <div
        className={cx({
          [styles.header]: true,
          [styles.is_centered]: titlePosition === 'center',
        })}
      >
        <h2 className={styles.title}>{title}</h2>
      </div>

      {menu && menu.length > 0 && (
        <Radio options={menu} selected={selected ?? menu[0]!.value} onChange={onMenu} />
      )}

      {children}

      {isMobile && onClose && (
        <Button ghost onClick={onClose}>
          {closeText ?? 'Закрыть'}
        </Button>
      )}
    </article>
  );
}
